import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 40,
    paddingBottom: 40,
    fontSize: 10,
    flexDirection: 'column',
  },
  borderFrame: {
    border: '8px solid #e4f4fd',
    padding: 16,
    flexGrow: 1,
  },
  divider: {
    borderBottom: '0.75pt solid #ccc',
    marginVertical: 6,
    width: '100%',
  },
  section: {
    marginBottom: 2,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 4,
    flexWrap: 'wrap',
  },
  infoMainHeaderView: {
    justifyContent: 'space-evenly',
    height: '100%',
    minWidth: '30%',
    maxWidth: '35%',
  },
  infoMainHeaderLabel: {
    fontWeight: 'bold',
    fontSize: 12,
    marginBottom: 2,
  },
  label: {
    fontWeight: 'bold',
    fontSize: 10,
    // marginRight: 4
  },
  value: {
    fontSize: 10,
  },
  sectionLabel: {
    fontWeight: 'bold',
    fontSize: 12,
    marginBottom: 10,
    marginTop: 5,
  },
  table: {
    width: '100%',
    marginTop: 12,
    // border: '1pt solid #333',
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableCellHeader: {
    flex: 1,
    padding: 2,
    fontWeight: 'bold',
    fontSize: 10,
    borderTop: '1pt solid #333',
    borderRight: '1pt solid #333',
    borderBottom: '1pt solid #333',
    textAlign: 'center',
  },
  tableFirstCell: {
    borderLeft: '1pt solid #333',
  },
  tableCell: {
    flex: 1,
    padding: 6,
    fontSize: 10,
    borderRight: '1pt solid #333',
    borderBottom: '1pt solid #333',
  },
  tableCellTop: {
    borderTop: '1pt solid #333',
  },
  classificationSection: {
    marginBottom: 10,
    borderBottomWidth: 1,
    borderColor: '#ccc',
    paddingBottom: 6,
  },
  classificationField: {
    width: '33.33%',
    fontSize: 10,
    paddingRight: 4,
  },
  classificationFullWidthField: {
    width: '100%',
    fontSize: 10,
    marginTop: 2,
  },
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 30,
    right: 30,
    textAlign: 'center',
    fontSize: 9,
    color: '#666',
    flexDirection: 'row',
    // justifyContent: 'space-between',
  },
  activitySetion: {
    marginBottom: 10,
    // borderBottom: '1 solid #ccc',
  },
  activityCellHeader: {
    flex: 1,
    padding: 2,
    fontWeight: 'bold',
    fontSize: 10,
    borderRight: '1pt solid #333',
    borderBottom: '1pt solid #333',
    textAlign: 'center',
  },
  activityRow: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    borderTopWidth: 1,
    borderLeftWidth: 1,
    borderColor: '#000',
  },
  activityInfo: {
    flexGrow: 1,
    padding: 6,
    borderBottomWidth: 2,
    borderRightWidth: 1,
    borderColor: '#000',
  },
  activityLabel: {
    fontSize: 10,
    fontWeight: 'bold',
  },
  activityValue: {
    fontSize: 10,
  },
  activityTableHeader: {
    fontSize: 10,
    fontWeight: 'bold',
    marginTop: 6,
    marginBottom: 2,
  },
  activityCell: {
    fontSize: 9,
    width: '12.5%',
    padding: 2,
  },
  activityTotalRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 5,
  },
  workOrderBottomCell: {
    flex: 1,
    padding: 6,
    fontSize: 10,
    borderRight: '1pt solid #333',
    borderBottom: '1pt solid #333',
    fontWeight: 'bold',
    textAlign: 'center',
    height: '100%',
  },
  classificationHeader: {
    flexDirection: 'row',
  },
  classificationRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    borderTop: 1,
    borderLeftWidth: 1,
    marginBottom: 8,
  },
  classificationCell: {
    flexGrow: 1,
    padding: 6,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderColor: '#000',
  },
  costActivityRow: {
    flexDirection: 'row',
    marginBottom: 5,
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    flexGrow: 1,
  },
  approverContainer: {
    flexDirection: 'row',
    marginBottom: 4,
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    flexGrow: 1,
    borderLeftWidth: 1,
    borderColor: '#000',
  },
  approverCell: {
    width: '25%',
    borderTopWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: '#000',
    padding: 5,
  },
  attachmentsView: {
    marginBottom: 3,
    width: '50%',
    paddingRight: 15,
    paddingLeft: 5,
  },
});

export default styles;
